import { Checkbox } from "components/ui/checkbox";
import { cn } from "lib/utils";
import { useEffect, useState } from "react";

interface InputProps {
  id: string;
  value: boolean | string; // Accepts boolean or string for flexibility
  label: string;
  onValueChange: (checked: boolean) => void;
  className?: string;
}

export default function CheckboxBoolean({
  id,
  value,
  label,
  onValueChange,
  className,
  ...props
}: InputProps) {
  // Initialize state based on value type
  const [selected, setSelected] = useState<boolean>(
    value === true || value === "1"
  );

  // Sync state with value prop changes
  useEffect(() => {
    setSelected(value === true || value === "1");
  }, [value]);

  // Handle checkbox changes
  const handleCheckedChange = (checked: boolean) => {
    setSelected(checked); // Update local state
    onValueChange(checked); // Notify parent
  };

  return (
    <div
      className={cn(`flex items-center space-x-2 cursor-pointer`, className)}
    >
      <Checkbox
        id={`checkbox_${id}`}
        checked={selected}
        onCheckedChange={handleCheckedChange}
        {...props}
      />
      <label
        htmlFor={`checkbox_${id}`}
        className="text-sm font-medium leading-none cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {label}
      </label>
    </div>
  );
}
